import { render, staticRenderFns } from "./DashboardLatestReservationList.vue?vue&type=template&id=36541dc6&scoped=true&"
import script from "./DashboardLatestReservationList.vue?vue&type=script&lang=js&"
export * from "./DashboardLatestReservationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36541dc6",
  null
  
)

export default component.exports